import apiSlice from "./apiSlice";
const ncrPackagesSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getAllNcr: builder.query({
            query: (req) => ({
                url: `ncr`,
                params: req
            }),
            providesTags:['GetAllNcrTag'],
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
        }),
        getNcrPackages: builder.query({
            query: ({ projectId, type }) => {
                const params = new URLSearchParams();
                if (projectId) params.append("projectId", projectId);
                if (type) params.append("type", type);
                return `WBS?${params.toString()}`;
            },
        }),
    }),
})

export const { useGetNcrPackagesQuery, useLazyGetNcrPackagesQuery, useGetAllNcrQuery } = ncrPackagesSlice
